module.exports = __webpack_public_path__ + "img/Weapon_194.9340d852.png";